export enum API {
  MARKETPLACE = 'marketplace',
  MASTER_DATA = 'master_data',
  CORE_FE_PROXY = 'core_fe',
  TENANT_SERVICE = 'tenant_service',
}

export enum CatalogueRoutes {
  APPLICATIONS = 'applications/*',
}
